import { Link } from "react-router-dom";


export const columns = (columnNames, i18n, t, permission, actionConfig = {}, handleRowClick) => {
    return (columnNames || [])?.map((column) => {
        let col;
        const title = i18n.language == 'ar' ? column.TitleAr : column.TitleEn

        switch (column?.FieldName) {

            case 'Action':
                return col = {
                    name: <span className='fw-bolder fs-13'>{i18n.language === 'ar' ? column?.ValueAr : column?.ValueEn}</span>,
                    sortable: false,
                    wrap: true,
                    selector: (item) => {
                        return <div className="hstack gap-3 flex-wrap justify-content-center" >
                            {Object.entries(actionConfig).map(([actionKey, actionProperties]) => {
                            // Handle visibility
                            const isVisible = typeof actionProperties.isVisible === "function"
                                ? actionProperties.isVisible(item, permission)
                                : true; 

                            if (!isVisible) return null;                            

                            // Prefer onClick from actionProperties if available
                            if (typeof actionProperties.onClick === 'function') {
                                return (
                                <Link
                                    key={actionKey}
                                    to="#"
                                    className={`fs-15 ${
                                    actionProperties.className || 
                                    (actionKey === 'view' ? 'link-info' : 
                                        actionKey === 'edit' ? 'link-success' :
                                        actionKey === 'delete' ? 'link-danger' :
                                        'link-primary') 
                                    }`}
                                    onClick={(e) => {
                                    e.preventDefault();
                                    actionProperties.onClick(item);
                                    }}
                                    title={actionProperties.tooltip ? t(actionProperties.tooltip) : (actionKey.charAt(0).toUpperCase() + actionKey.slice(1))}
                                >
                                    <i className={actionProperties.icon}></i>
                                </Link>
                                );
                            }

                            })}
                        </div>

                    },
                }

            case 'Normal-Cursor': 
                return col = {
                    name: <span className='fw-bolder fs-13'>{i18n.language === 'ar' ? column?.ValueAr : column?.ValueEn}</span>,
                    selector: row => (
                        <span className="cursor-pointer" onClick={() => handleRowClick(row, title)}>{row[title]}</span>
                    ),
                    sortable: true,
                    wrap: true
                }

            case 'Normal-Color-Cursor': 
                return col = {
                    name: <span className='fw-bolder fs-13'>{i18n.language === 'ar' ? column?.ValueAr : column?.ValueEn}</span>,
                    selector: row => (
                        <span className={`wrap-text cursor-pointer ${(row.JsonFieldUpdated || []).includes(title) ? 'text-success' : 'text-danger'}`} onClick={() => handleRowClick(row, title)}>{row[title]}</span>
                    ),
                    sortable: true,
                    wrap: true
                }

            case 'List-Cursor': 
                return col = {
                    name: <span className='fw-bolder fs-13'>{i18n.language === 'ar' ? column?.ValueAr : column?.ValueEn}</span>,
                    selector: row => (
                        <ul style={{marginTop: '1rem'}} className={`${(row.JsonFieldUpdated || []).includes('InstrumentType') ? 'text-success' : 'text-danger'}`}>
                            {row[title].map((item, index) => (
                                <li className="cursor-pointer" key={index} onClick={() => handleRowClick(row, title)}>{item}</li>
                            ))}
                        </ul>
                    ),
                    sortable: true,
                    wrap: true
                }

            default:
                return col = {
                    name: <span className='fw-bolder fs-13'>{i18n.language === 'ar' ? column?.ValueAr : column?.ValueEn}</span>,
                    selector: row => {
                        return ['CreatedDate', 'ModifiedDate'].includes(title) ? new Date(row[title]).toLocaleString(i18n.language, { timeStyle: 'short' }) : 
                        row[title]
                    },
                    sortable: true,
                    wrap: true
                }
        }
    })
}